var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20999 2.26782C8.64468 1.79685 8.86203 1.56137 9.09298 1.42401C9.65026 1.09258 10.3365 1.08227 10.903 1.39682C11.1378 1.52719 11.3619 1.75604 11.8099 2.21375C12.258 2.67145 12.482 2.90031 12.6096 3.14018C12.9176 3.71895 12.9075 4.41993 12.583 4.98921C12.4486 5.22514 12.218 5.44717 11.757 5.89122L6.27153 11.1746C5.39784 12.0161 4.96099 12.4369 4.41503 12.6501C3.86906 12.8634 3.26886 12.8477 2.06845 12.8163L1.90513 12.812C1.53969 12.8025 1.35697 12.7977 1.25075 12.6772C1.14454 12.5566 1.15904 12.3705 1.18804 11.9982L1.20379 11.7961C1.28541 10.7484 1.32623 10.2245 1.53082 9.7536C1.73542 9.28269 2.08833 8.90032 2.79416 8.13559L8.20999 2.26782Z",
    stroke: "#141B34",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5835 2.33398L11.6668 6.41732",
    stroke: "#141B34",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 12.834L12.8337 12.834",
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconNew);
export default __webpack_public_path__ + "static/media/editIconNew.ec0d13ae33942e9932c1a0b631966420.svg";
export { ForwardRef as ReactComponent };